import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import './Portfolio.css';

function Portfolio() {
  const [filter, setFilter] = useState('all');

  // Portfolio projects data dengan client yang puas dan tahun pengalaman yang realistis
  const projects = [
    {
      id: 1,
      title: 'Asisten Dosen Berbasis AI untuk Pendidikan Modern',
      category: 'EdTech, AI in Education, AI Teaching Assistant / Virtual Assistant for Academia',
      client: 'Yasha Langgita',
      clientUrl: '/client',
      description: 'Website landing page dan company profile modern yang dirancang untuk memperkenalkan platform asisten dosen berbasis AI, membantu otomatisasi administrasi akademik, penyusunan RPS, dan pembuatan bahan ajar.',
      image: `${process.env.PUBLIC_URL}/images/portofolio/Asistendosenai2.png`,
      tags: ['React', 'Tailwind CSS', 'JavaScript', 'Responsive Design', 'AI Integration'], // Sesuaikan tech stack Anda
      features: [
        'Beranda / Landing Page',
        'Fitur Unggulan (Penyusunan RPS & Bahan Ajar)',
        'Tentang Platform',
        'Paket Layanan / Pricing',
        'Kontak & Formulir Demo',
        'Mobile Responsive Design'
      ],
      year: '2025',
      url: 'https://asistendosenai.id', // Atau gunakan URL demo/produksi project AI Anda
      clientSatisfaction: '100%',
      experience: '1+ Tahun'
    },
    {
      id: 2,
      title: 'Medius Quran - Educational Platform',
      category: 'web aplikasi, application',
      client: 'Medius Quran',
      description: 'Platform edukasi Al-Quran modern dengan sistem analisis diri, video pembelajaran, dan wellness tracking untuk pengembangan spiritual.',
      image: `${process.env.PUBLIC_URL}/images/portofolio/web-aplikasi-medius-quran-educational-platform.jpeg`,
      tags: ['HTML5', 'CSS3', 'JavaScript', 'Responsive Design'],
      features: [
        'Landing Page Profesional',
        'Sistem Analisis Diri',
        'Video Introduction',
        'CTA Button',
        'Navigasi Modular berbasis konsep',
        'Branding Visual Modern (dark UI, clean, tech feel)',
        'Spiritual / energi diri',
        'Personal development',
        'Wellness system'
      ],
      year: '2026',
      url: 'https://medius-quran.gt.tc/',
      clientSatisfaction: '85%',
      experience: '1 Tahun'
    },
    {
      id: 3,
      title: 'Sewa Bus Jabodetabek - Booking System',
      category: 'website',
      client: 'Sewa Bus Jabodetabek',
      description: 'Website booking transportasi modern dengan sistem reservasi real-time, manajemen armada, dan dashboard pelanggan untuk layanan sewa bus.',
      image: `${process.env.PUBLIC_URL}/images/portofolio/website-sewa-bus-jabodetabek-booking-system.png`,
      tags: ['HTML 5', 'CSS', 'JavaScript'],
      features: [
        'Real-time booking system',
        'Fleet management',
        'Customer dashboard',
        'Payment integration',
        'Schedule management',
        'Route optimization'
      ],
      year: '2024',
      url: 'https://sewa-bus-jabodetabek.netlify.app/',
      clientSatisfaction: '90%',
      experience: '1 Tahun'
    },
    {
      id: 4,
      title: 'Cakra Digital Innovation - Company Profile',
      category: 'website',
      client: 'Cakra Digital Innovation',
      clientUrl: '/client',
      description: 'Website company profile modern dengan desain profesional, fitur lengkap, dan integrasi feedback form untuk menampilkan layanan digital agency.',
      image: `${process.env.PUBLIC_URL}/images/portofolio/website-cakra-digital-innovation-company-profile.png`,
      tags: ['React', 'React Router', 'CSS3', 'Responsive Design'],
      features: [
        'Company profile profesional',
        'Layanan digital terintegrasi',
        'Feedback form interaktif',
        'About section lengkap',
        'Dark mode support',
        'Mobile responsive design'
      ],
      year: '2026',
      url: 'https://cakra-digital-deploy.vercel.app',
      clientSatisfaction: '100%',
      experience: '1+ Tahun'
    }
  ];

  const categories = [
    { id: 'all', name: 'Semua Proyek' },
    { id: 'website', name: 'Website' },
    { id: 'web aplikasi', name: 'Web Aplikasi' },
    { id: 'application', name: 'Aplikasi' },
    { id: 'ecommerce', name: 'E-Commerce' },
    { id: 'saas', name: 'SaaS' }
  ];

  const filteredProjects = filter === 'all'
    ? projects
    : projects.filter(project => project.category.includes(filter));

  // Sort projects: newest first, then others
  const sortedProjects = [...filteredProjects].sort((a, b) => {
    // Get latest year as "newest"
    const yearA = parseInt(a.year) || 0;
    const yearB = parseInt(b.year) || 0;
    return yearB - yearA;
  });

  return (
    <>
      {/* Structured Data for SEO */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          "name": "Portfolio Cakra Digital Innovation",
          "description": "Karya digital terbaik untuk bisnis modern - Website development, SEO optimization, dan digital marketing services",
          "url": "https://cakra-digital-deploy.vercel.app/portfolio",
          "mainEntity": {
            "@type": "ItemList",
            "itemListElement": sortedProjects.map((project, index) => ({
              "@type": "ListItem",
              "position": index + 1,
              "item": {
                "@type": "CreativeWork",
                "name": project.title,
                "description": project.description,
                "image": `https://cakra-digital-deploy.vercel.app${project.image}`,
                "url": project.url,
                "creator": {
                  "@type": "Organization",
                  "name": "Cakra Digital Innovation",
                  "url": "https://cakra-digital-deploy.vercel.app"
                },
                "dateCreated": project.year,
                "about": project.category,
                "keywords": project.tags.join(", "),
                "client": project.client
              }
            }))
          }
        })}
      </script>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero__inner">
          <div className="hero__content">
            <div className="hero__text-content">
              <span className="hero__eyebrow">Portfolio Kami</span>
              <h1 className="hero__title">Karya Digital Terbaik untuk Bisnis Modern</h1>
              <p className="hero__subtitle">
                Eksplorasi proyek-proyek terbaik kami yang menggabungkan inovasi teknologi dengan desain yang memukau.
              </p>
              <div className="hero__divider"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Statistics Section */}
      <section className="section section-sm">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">{projects.length}+</div>
              <div className="stat-label">Proyek Selesai</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">{projects.length}+</div>
              <div className="stat-label">Client Puas</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">1+</div>
              <div className="stat-label">Tahun Pengalaman</div>
            </div>
          </div>
        </div>
      </section>

      {/* Filter Section */}
      <section className="section section-sm">
        <div className="container">
          <div className="filter-container">
            {categories.map(category => (
              <button
                key={category.id}
                onClick={() => setFilter(category.id)}
                className={`filter-btn ${filter === category.id ? 'active' : ''}`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Portfolio Grid */}
      <section className="section">
        <div className="container">
          <div className="portfolio-grid">
            {sortedProjects.map((project, index) => (
              <article
                key={project.id}
                className={`portfolio-card ${index === 0 ? 'new-project' : ''}`}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="portfolio-card__image-wrapper">
                  <figure>
                    <img
                      src={project.image}
                      alt={`Website ${project.title} - ${project.description} oleh Cakra Digital Indonesia`}
                      title={`${project.title} - ${project.category} oleh ${project.client}`}
                      className="portfolio-card__image"
                      loading="lazy"
                      decoding="async"
                    />
                    <figcaption className="sr-only">
                      {project.title} - {project.category} untuk {project.client}. {project.description}
                    </figcaption>
                  </figure>
                  <div className="portfolio-card__overlay">
                    <span className="portfolio-card__category">
                      {project.category === 'website' ? 'Website' :
                        project.category === 'application' ? 'Aplikasi' :
                          project.category === 'ecommerce' ? 'E-Commerce' :
                            project.category === 'saas' ? 'SaaS' : 'Digital'}
                    </span>
                  </div>
                </div>

                <div className="portfolio-card__content">
                  <div className="portfolio-card__header">
                    <h3 className="portfolio-card__title">{project.title}</h3>
                    <div className="portfolio-card__client-info">
                      <p className="portfolio-card__client">
                        Klien: {project.client}
                      </p>
                      <div className="portfolio-card__metrics">
                        <div className="portfolio-card__metric">
                          <span className="portfolio-card__satisfaction">{project.clientSatisfaction}</span>
                          <span className="portfolio-card__metric-label">Kepuasan</span>
                        </div>
                        <div className="portfolio-card__metric">
                          <span className="portfolio-card__experience">{project.experience}</span>
                          <span className="portfolio-card__metric-label">Pengalaman</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p className="portfolio-card__description">
                    {project.description}
                  </p>

                  <div className="portfolio-card__tags">
                    {project.tags.slice(0, 3).map((tag, tagIndex) => (
                      <span key={tagIndex} className="portfolio-card__tag">
                        {tag}
                      </span>
                    ))}
                    {project.tags.length > 3 && (
                      <span className="portfolio-card__tag-more">
                        +{project.tags.length - 3}
                      </span>
                    )}
                  </div>

                  <div className="portfolio-card__footer">
                    <span className="portfolio-card__year">{project.year}</span>
                    {project.url && (
                      <a
                        href={project.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="portfolio-card__link"
                        aria-label={`Lihat proyek ${project.title}`}
                      >
                        Lihat Proyek
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"></path>
                          <polyline points="15,3 21,3 21,9"></polyline>
                          <line x1="10" y1="14" x2="21" y2="3"></line>
                        </svg>
                      </a>
                    )}
                  </div>
                </div>
              </article>
            ))}

            {filteredProjects.length === 0 && (
              <div className="portfolio-empty">
                <h3>Belum ada proyek dalam kategori ini</h3>
                <p>Proyek akan segera ditambahkan. Tetap update dengan kami!</p>
                <Link to="/consultation" className="btn btn-primary">
                  Diskusikan Proyek Anda
                </Link>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section section-sm">
        <div className="container">
          <div className="cta-section">
            <h2>Siap Memulai Proyek Digital Anda?</h2>
            <p>Konsultasi gratis untuk solusi website dan aplikasi bisnis Anda.</p>
            <div className="cta-buttons">
              <Link to="/consultation" className="btn btn-primary">
                Mulai Konsultasi
              </Link>
              <Link to="/pricing" className="btn btn-secondary">
                Lihat Harga
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Portfolio;
